$(function(){




  // Announcement Bar

  
  if($(window).width()>1100){
    $(".country-select").hover(function() {
      $(this).toggleClass("show-box");
         if($(this).find(".select-menu").is(":hidden")){
          $(this).addClass("active");
           $(this).find(".toggle-box").addClass("active");
         }
         else{
          $(this).removeClass("active");
           $(this).find(".toggle-box").removeClass("active");
         }
         $(this).find(".select-menu").stop(true).slideToggle();
       
       });
       $(".announcement-bar-box .country-select").hover(function() {
        $("body").toggleClass("mask overflow-hidden");
      })
  }else{
    $(".country-select").click(function() {
      $(this).toggleClass("show-box");
        
          $(this).toggleClass("active");
           $(this).find(".toggle-box").toggleClass("active");
           $(this).find(".select-menu").stop(true).slideToggle();
       });
       
  }

//  $("body").click(function(evt){
//    if($(evt.target).parents(".country-select").length==0 && $(evt.target).parents(".country-select .toggle-box").length==0) {
//      $(`.country-select .toggle-box`).removeClass("active");
//      $(".country-select .select-menu").stop(true).slideUp();
//      $("body").removeClass("mask overflow-hidden");
//      $(".country-select").removeClass("show-box");
//      $(".country-select").removeClass("active");
//      $(this).find(".toggle-box").removeClass("active");
//     }
//   });
  // Custom Country Bar
  var goLink = $(`.selector-box .selector-list .list-item.active`).attr("data-url");
  var currText = $(`.selector-box .selector-list .list-item.active`).text();
  $(`.selector-box .selector-current .current-title`).text(currText);
   $(".selector-box .selector-current").click(function() {
     if($(this).siblings(".selector-list").is(":hidden")){
       $(this).addClass("active");
       $(this).find(".toggle-btn").addClass("active");
     }
     else{
       setTimeout(()=>{
         $(this).removeClass("active");
       },200);
       $(this).find(".toggle-btn").removeClass("active");
     }
     $(this).siblings(".selector-list").slideToggle();
   });
   $("body").click(function(evt){
     if($(evt.target).parents(".selector-box").length==0 && $(evt.target).parents(".selector-box .toggle-btn").length==0) {
      setTimeout(()=>{
         $(".selector-box .selector-current").removeClass("active");
       },200);
       $(`.selector-box .toggle-btn`).removeClass("active");
       $(".selector-box .selector-list").slideUp();
      }
    });
  $(`.selector-box .selector-list .list-item`).click(function(){
    let tempText = $(this).text();
    goLink = $(this).attr("data-url");
    $(`.selector-box .selector-current .current-title`).text(tempText);
    $(this).addClass("active").siblings().removeClass("active");
    $(`.selector-box .toggle-btn`).removeClass("active");
    setTimeout(()=>{
       $(".selector-box .selector-current").removeClass("active");
     },200);
     $(".selector-box .selector-list").slideUp();
  });
  $(`.custom-country-bar .go-button`).click(function(){
    window.location.href = goLink;
  });
  $(`.custom-country-bar .close-container`).click(function() {
    $(`.custom-country-bar`).remove();
  });
  
})


$('.site-footer__item-inner--link_list .h4').click(function () {

let status = $(this).data('status');

if ($(window).width() <= 999) {

  $(this).next('ul.site-footer__linklist').slideToggle();

  if (!status) {

    $(this).find('.i-plus').hide();

    $(this).find('.i-minus').show();

    $(this).data('status', true);

    return

  }

  else {
    $(this).find('.i-plus').show();
    $(this).find('.i-minus').hide();
    $(this).data('status', false);
    return
  }
}
})



// color swatch
$("body").on("click",".color-swatch-item",function(){
let id=$(this).data("id"),pid=$(this).data("pid");
$(this).addClass("active").siblings().removeClass("active");
$(`.img-variant-${id}`).addClass("active").siblings().removeClass("active");
$(`#vairant-${pid}`).val(id);
})










// flow-battery
$(function(){

if($("body").hasClass("template-flow-new")){

  window.addEventListener("scroll", function(event)
  {
      event = event || window.event;

      var scrollTop = $(this).scrollTop();   
      
      var batterytop = $(".flow-battery-section").offset().top;
      
      var fixedtabbar = $(".site-header").height();
      if($(window).width() >= 768 ){
        if( scrollTop + (fixedtabbar * 2) >= batterytop ){
          $(".flow-180-batterysvg svg").css("filter","brightness(1)");
          $(".flow-180-batterysvg svg").css("-webkit-filter","brightness(1)");
        }else{
          $(".flow-180-batterysvg svg").css("filter","brightness(0.5)");
          $(".flow-180-batterysvg svg").css("-webkit-filter","brightness(0.5)");
        }
      }else{
        if( scrollTop + (fixedtabbar * 4.5) >= batterytop ){
          $(".flow-180-batterysvg svg").css("filter","brightness(1)");
          $(".flow-180-batterysvg svg").css("-webkit-filter","brightness(1)");
        }else{
          $(".flow-180-batterysvg svg").css("filter","brightness(0.5)");
          $(".flow-180-batterysvg svg").css("-webkit-filter","brightness(0.5)");
        }
      }
        
      
        // flow-icon-bg
        // var iconbgheight = $(".flow-icon-background").height();
        // var iconbgtop = $(".flow-icon-background").offset().top;
        // var bgpercent = 0;
        // var bg_bottom = iconbgtop + iconbgheight;
        // if($(window).width() >768){
        //   if (scrollTop >= iconbgtop && scrollTop <= bg_bottom) {
        //       bgpercent = ((scrollTop - iconbgtop) / (iconbgheight)) * 130 ;
        //       $(".flow-icon-box").css("background-position","center " + bgpercent  + "%");
        //   }
        // }
  });

  // flow brush head

  var breakdown_swiper = new Swiper('.breakdown-swiper-container', {
    pagination: false,
    slidesPerView: 4,
    spaceBetween: 20,
    loop:false,
    noSwiping : true,
    autoplay:false,
    paginationClickable: true,
    observer:true,
    observeParents:true,
    breakpoints: {
      320: {
       
        slidesPerView: 1.1
      },
      999: {
        slidesPerView: 4,
      },
    },
  });

  var flowicon_swiper = new Swiper('.flowicon-swiper-container', {
    pagination: {
      el: '.swiper-pagination-icon-wap',
    },
    slidesPerView: 3,
    // spaceBetween: 35,
    slidesPerGroup : 3,
    paginationClickable: true,
    direction: 'vertical',
    observer:true,
    observeParents:true,
    breakpoints: {
      320: {
        spaceBetween: 0,
      },
      589: {
        spaceBetween: 30,
      },
    },
  });



  if($(window).width()<= 1280){
    $('.breakdown-swiper-wrapper .breakdown-slide-item').each(function(d) {
      let that=$(this);
      that.removeClass("swiper-no-swiping");
    })
  }

  $(window).resize(function(){
    if($(window).width()<= 1280){
      $('.breakdown-swiper-wrapper .breakdown-slide-item').each(function(d) {
        let that=$(this);
        that.removeClass("swiper-no-swiping");
      })
    }else{
      $('.breakdown-swiper-wrapper .breakdown-slide-item').each(function(d) {
        let that=$(this);
        that.addClass("swiper-no-swiping");
      })
    }
  })

  
  


  $(window).resize(function(){
    var ipadwidth = $(window).width();
    var ipadheight = $(window).height();
    if( ipadwidth == 1280 && ipadheight == 820){
      $(".flow-icon-box").css({ "background-attachment": "unset !important" });
    }
  })





let browerType = "";
$(document).ready(function () {
    browerType = myBrowser();
    parallax('.flow-icon-background .flow-icon-box');
})

function myBrowser() {
    var userAgent = navigator.userAgent;
    var isOpera = userAgent.indexOf("Opera") > -1;
    var isIE = userAgent.indexOf("compatible") > -1 &&
        userAgent.indexOf("MSIE") > -1 && !isOpera;
    var isEdge = userAgent.indexOf("Edge") > -1;
    var isFF = userAgent.indexOf("Firefox") > -1;
    var isSafari = userAgent.indexOf("Safari") > -1 &&
        userAgent.indexOf("Chrome") == -1;
    var isChrome = userAgent.indexOf("Chrome") > -1 &&
        userAgent.indexOf("Safari") > -1;

    if (isIE) {
        var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
        reIE.test(userAgent);
        var fIEVersion = parseFloat(RegExp["$1"]);
        if (fIEVersion == 7) {
            return "IE7";
        } else if (fIEVersion == 8) {
            return "IE8";
        } else if (fIEVersion == 9) {
            return "IE9";
        } else if (fIEVersion == 10) {
            return "IE10";
        } else if (fIEVersion == 11) {
            return "IE11";
        } else {
            return "0";
        }
        return "IE";
    }
    if (isOpera) {
        return "Opera";
    }
    if (isEdge) {
        return "Edge";
    }
    if (isFF) {
        return "Firefox";
    }
    if (isSafari) {
        return "Safari";
    }
    if (isChrome) {
        return "Chrome";
    }

  }

  function parallax(el) {
    let parallax_image = $(el) || '';
    let enable_parallax = true;
    if (enable_parallax) {
        parallax_image.css({
            "background-attachment": "fixed"
        });
    }
    if (browerType == "IE") {
        parallax_image.css({
            "background-attachment": "unset !important"
        });
        parallax_image.css({
          "background-size": "contain !important"
      });
    }
    if (browerType == "Safari") {
        parallax_image.css({
            "background-attachment": "unset !important"
        });
        parallax_image.css({
          "background-size": "contain !important"
      });
      $(".flow-icon-box").css("background-attachment", "scroll");
      // $(".flow-icon-box").css("background-size", "contain");
      $(".flow-icon-box").css("background-position-y", "0");
      
    }

    window.addEventListener("scroll", function () {
        let t = 0;
        if ($(window).width() > 1023) {
            // if (browerType == "Firefox") {
            //     t = document.documentElement.scrollTop / 30;
            //     parallax_image.css('background-position-y', `-${t}px`);
            // }
            if ( browerType != "Safari") {
                // t = document.documentElement.scrollTop / 30;
                // parallax_image.css('background-position-y', `-${t}px`);
              let scrollTop = $(this).scrollTop();   
              let iconbgheight = $(".flow-icon-background").height();
              let iconbgtop = $(".flow-icon-background").offset().top;
              let bgpercent = 0;
              let bg_bottom = iconbgtop + iconbgheight;
              if (scrollTop >= iconbgtop && scrollTop <= bg_bottom) {
                  bgpercent = ((scrollTop - iconbgtop) / (iconbgheight)) * 130 ;
                  $(".flow-icon-box").css("background-position","center " + bgpercent  + "%");
              }
              
            }

            if (browerType == "Safari") {
              $(".flow-icon-box").css('height', `150vh`);
              if($(window).width() < 1200){
                $(".flow-icon-box").css('background-position-y', `0px`);
                // $(".flow-icon-box").css("background-size", "contain");
                $(".flow-icon-box").css("background-position","center ");
                $(".flow-icon-box").css("height","100vh");
              }
              
            }
        }
      
    })
  }

}
})


 
$(document).ready(function(){
if($(window).width()>589){
if($("body").hasClass("template-index")){}else{
if($("#MainContent .section:eq(0)").hasClass("slideshow-container")){
  $(".section-header").addClass("section-header-transparent has-slideshow");
}
}
}
})